import Main from "../components/LoginFlowComponent/Main";
import { useEffect, useState } from "react";

import { msalInstance1 } from "../services/msal";
import { useRouter } from "next/router";
import { LogoutUserState, extraReducers } from '../store/Slicer/UserSlice';
import { useDispatch, useSelector } from "react-redux";
import LoadingDailog from "../Helper/LoadingDailog";
import { NEXT_API_URL } from "../Helper/Config";


export async function getServerSideProps() {
  const response = await fetch(
    `${NEXT_API_URL}/bizcareui/api/Registration/addUserDB`
  );
  const results = await response.json();

  return { props: { result: results } };
}

export default function Home({ result }) {
  const [adminToken, setAdminToken] = useState('');
  // const [screenName, setScreenName] = useState('login');
  const [screenName, setScreenName] = useState(null);
  // const [noShow, setNoshow]= useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  //const [noShow, setNoshow]= useState(false);
  // const dispatch = useDispatch();
    // const router = useRouter();
    const router = useRouter();
    const { user } = useSelector((state) => state.user);

  // useEffect(()=>{
  //   console.log("active account", msalInstance1.getActiveAccount());
  //   console.log("adminToken", adminToken);
  //   if (window.sessionStorage.getItem('loginType') === 'AD' && adminToken != '') {
  //     console.log("inside if first");
      
    
  //     // router.push({
  //     //   pathname: '/Celcom_dashboard',
  //     //   query: { id_token: idToken },
  //     // });
  //     window.location.href = `${NEXT_API_URL2}/bizcareui/api/auth/authAdmin?id_token=${adminToken}`;
      
  //   }  
  //   else if(window.sessionStorage.getItem('loginType') != 'AD') {
  //     console.log("inside if first else");
  // // window.sessionStorage.setItem('loginType', '');
  //   console.log("inside use effect else");
   
  //   // dispatch(LogoutUserState());
  //   //   setLoginCheck(true);
  //   setIsLoading(false);
  //   router.push('/');
  // }
  // },[window.sessionStorage.getItem('loginType')]);
  useEffect(()=>{
    setScreenName('login');
  //  if(router.pathname === "/" && router.pathname != "/ManageCompany" && screenName==='login'){
  //   // alert('hi', screenName);
  //   window.sessionStorage.setItem('loginType','');
  //   setNoshow(true);
  // }
    // if(window.sessionStorage.getItem('loginType') != 'AD' && !msalInstance1.getActiveAccount()){
    //   setNoshow(true);
    // }else if(msalInstance1.getActiveAccount()){
    //   setNoshow(false);
    //   setScreenName(null);
    //   console.log("inside else");
    //   window.location.href = `${NEXT_API_URL}/bizcareui/api/auth/authAdmin?id_token=${adminToken}`;
    // }
    
      // if(window.sessionStorage.getItem('loginType') == 'AD' && msalInstance1.getActiveAccount()){
      // //  alert('inside main page');
      //   window.location.href = `${NEXT_API_URL}/bizcareui/api/auth/authAdmin?id_token=${adminToken}`;
      // }
  },[])

  return (
    <>{screenName && (
      <Main
          adminToken={adminToken}
          setAdminToken={setAdminToken}
          screenName = {screenName}
          setScreenName = {setScreenName}
          
        />
    )
      
    
    
    }
    </>
      
    
  );
}
